import { h, Fragment } from 'preact';
import { useEffect, useRef, useState, useReducer } from 'preact/hooks';
import { i18n, BeansLiquidEngine, riperStorage } from '@/base/helpers';
import Redeem from '@/liana/views/modals/Redeem';
import { useTemplet } from '@/liana/hooks';
import { getDataButton } from '../utils';

export default function CartButton(props) {
  // props: { account, cart, coupon, display, onAbout, buttonClass }
  const domRef = useRef(null);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [state, setState] = useState({
    account: props.account,
    coupon: props.coupon,
    cart: props.cart,
    status: '',
    message: '',
  });

  const { status, message, account, coupon, cart } = state;

  const { templet, templetLoading } = useTemplet({ ruleUid: 'rule:liana:display_cart' });

  const { textButton, clickButton, classButton, textInfo } = getDataButton({
    account,
    coupon,
    status,
    message,
    cartValue: cart?.total_price,
    display: props.display,
    onAbout: props.onAbout,
  });

  function handleRedemption(event) {
    setState((prevState) => ({ ...prevState, ...event.detail }));
    forceUpdate();
  }

  useEffect(() => {
    domRef?.current?.addEventListener('event:liana:redemption', handleRedemption);
    setState((prevState) => ({
      ...prevState,
      account: riperStorage.account,
      cart: riperStorage.cart,
      coupon: riperStorage.coupon,
    }));

    return () => {
      domRef?.current?.removeEventListener('event:liana:redemption', handleRedemption);
    };
  }, [templetLoading]);

  if (templet) {
    window.Beans3.Liana.Actions = {
      ...window.Beans3.Liana.Actions,
      onRedeem: clickButton,
    };

    const renderedTempletHTML = BeansLiquidEngine.parseAndRenderSync(templet.html, {
      account,
      info_text: textInfo,
      button_text: textButton,
      button_class: `${props.buttonClass} ${classButton}`,
      Params: templet.settings,
    });

    return (
      <Fragment>
        {}
        <div ref={domRef} dangerouslySetInnerHTML={{ __html: renderedTempletHTML }} />
        <Redeem
          title={
            status === 'error'
              ? i18n.t('redemption', 'redemption_failed')
              : i18n.t('redemption', 'you_redeemed_x_points', {
                  beans_name: props.display.beans_name,
                  quantity: coupon ? coupon.amount * 100 : 0,
                })
          }
          isOpen={(status === 'done' && !!coupon && !props.display.is_auto_checkout) || status === 'error'}
          onClose={() => setState((prevState) => ({ ...prevState, status: '' }))}
          status={status}
          message={status === 'error' ? message : textInfo}
          coupon={coupon}
        />
      </Fragment>
    );
  }
}
